import { useQuery } from '@tanstack/react-query';

import { IHeart, IHeartAndBall } from '../models';
import { $api, $apiWithoutClient } from '../service';
import { globalConst } from '..';

export const useGetHeartData = () => {
  const { data, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.GET_HEART_DATA],
    queryFn: async () => {
      const { data } = await $apiWithoutClient.get<IHeart>('/heart/view');

      return { heartData: data };
    },
  });

  return { ...data, ...args };
};

export const useGetHeartBallData = () =>
  useQuery({
    queryKey: [globalConst.queryKeys.GET_HEART_XP_DATA],
    queryFn: async () => {
      const { data } = await $api.get<IHeartAndBall>('/heart-count');

      return data;
    }
  });
